import '../Sass/App.scss';
import React from 'react';
import { ReadmePage } from './ReadmePage';

const RULE_SECTIONS = [
    {
        title: 'requirements',
        blocks: [
            'To develop a Codebase, you will need to create a Malware profile and be logged in on this site.',
            {
                type: 'code',
                // tone: 'info',
                // label: 'recommendation',
                text: 'At this time, you may design only Codebases. In the future we will allow users to design other components (e.g. Machine Learning decks, Viruses, etc.), at which point this development guide will be updated.'
            },
            {
                type: 'actions',
                actions: [
                    { label: 'login', page: 'login', sendId: '' }
                ]
            }
        ]
    },
    {
        title: 'creating_your_first_codebase',
        blocks: [
            'After logging in, navigate to the Documentation page (type "docs" into the command prompt) and click the "develop new codebasde" button in the top-right of the screen.',
            'A new Codebase with placeholder information will be created, and should be visible in the drop-down at the top-left of the Documentation screen. Any time you want to view or edit your Codebase, you can select it here (as long as you are logged in).',
            'Click the "edit" button under that drop-down to start editing the Codebase you have selected. You will see several buttons appear throughout the Documentation page that allow you to modify Codebase header data, individual cards, instructions, and more.',
            {
                type: 'actions',
                actions: [
                    { label: 'Codebase documentation', page: 'documentation', sendId: '' },
                ]
            }
        ]
    },
    {
        title: 'game_information',
        blocks: [
            'Basic game information appears at the top of the Documentation page. Click the "edit game info" button to view and edit the following elements:',
            {
                type: 'list',
                items: [
                    'Banner Image: an image with a 4:1 aspect ratio that will represent your Codebase on this site\'s Shop and Documentation pages',
                    'Name: the name of your Codebase, up to 30 characters',
                    'Description: a brief tagline or hook meant to intrigue developers',
                    'Flavor Text: a slightly longer description (typically 1-2 sentences) intended to describe the theme or mechanics of the Codebase',
                    'Default Card Back: optional. An image with a 1:1.4 aspect ratio that will be shown on the back of all the cards within the Codebase by default. You can override this at the individual card level (see below).'
                ]
            },
            'Note that you cannot edit the price of your Codebase. This is determined by Malware admins after your Codebase has been approved for distribution through the Shop.',
            'You can also delete your Codebase from the "edit game info" menu. Note that if you delete your Codebase, it cannot be restored.'
        ]
    },
    {
        title: 'instructions',
        blocks: [
            'If your game contains any special cards that require instructions, or unique game mechanics that require further explanation, you can add those to this section.',
            'To delete an instruction, first click "edit" then "delete instruction."'
        ]
    },
    {
        title: 'cards',
        blocks: [
            'The cards comprising your Codebase are grouped by type and are displayed beneath any instructions you have added.',
            'To add a new card, click the "add" button next to the section header corresponding with the card type you wish to add. You can modify existing cards by clicking the "edit" button on the card.',
            'Each card includes the following editable elements:',
            {
                type: 'list',
                items: [
                    'Card Type: the type of card you are designing -- procedure, function, listener, program or special. Type "rules" to learn more about card types in Malware.',
                    'Special Card Type: used only for special cards. This is the name of the custom card type you are designing. For example, "ceo" is a special card type within the Corporate Code Farm Codebase.',
                    'Quantity: the number of copies of the card in your Codebase.',
                    'Card Title #1: optional. The first portion of the name of your card, which will appear in regular font weight.',
                    'Card Title #2: The rest of the name of your card, which will appear in bold font weight. If your card name is a single word, put it here rather than in Card Title #1.',
                    'Argument: optional. A number or variable (x, y, z) referenced in the card description, which could be modified by other cards. For example, another card could double the value of an argument for one turn. This will appear in parentheses next to your card title.',
                    'Suffix: optional. You may want to add a semicolon after your card title, for example... we all know what happens when you forget semicolons.',
                    'Description Block #1: a description of what your card does. For program cards, this is the only Description block available.',
                    'Description Block #2: optional. In some scenarios you may want to describe a secondary or conditional effect of a card.',
                    'Header #1: optional. This appears before the Description Block #1. It is usually unnecessary, but may be helpful if you want to differentiate a primary effect from a secondary effect or something along those lines.',
                    'Header #2: optional. This appears befofe the Description Blobk #2. It typically describes why or when that second description applies.',
                    'Card Image: The image printed on the front of your card. For the program card type, this should be portrait with a 1:2 aspect ratio. For all other card types, this must be landscape in a 2:1 aspect ratio.',
                    'Card Icon: optional. A small square icon that appears to the right of your card\'s title. May designate some unique effect or card status.',
                    'Card Back Override: optional. An image with a 1:1.4 aspect ratio that will be shown on the back of the card. This overrides the "Defauult Card Back" image (if set) at ont the Codebase.'
                ]    
            },
            'Though not strictly required, it is recommended that you adhere to the following principles when designing cards:',
            {
                type: 'list',
                items: [
                    'Codebases should contain exactly 24 cards.',
                    'Add a semicolon (using the "Suffix" field) to any procedure cards you design.',
                    'All Codebases should have at least one -- and typically just one -- program card.',
                    'You don\'t have to design any special card types, but if you do, it is recommended that you design only one special card type.',
                    'When writing descriptions, be sure to use the vocabulary Malware (i.e. refer to players as developers, etc.). Type "rules" to get a sense of that vocabulary.',
                ]
            },   
            {
                type: 'image',
                src: 'https://placehold.co/100x200',
                alt: 'Card example',
                label: 'figure 01',
                caption: 'Understanding the various elements of a card in Malware.'
            }         
        ]
    },
    {
        title: 'playtesting_and_sharing',
        blocks: [
            'You can playtest any Codebase you own (i.e. those that you designed while logged into this site) using our online playtest engine by typing "playtest" and selecting your Codebase (along with any others you wish to test alongside it).',
            'You can also invite other users to view and playtest your Codebase -- even when it is in draft status -- by adding them to the "Privelged Users" list using the "edit game info" form. Note that adding a user to that list will not automatically notify them that they have been added; you will need to do that yourself. Next time they log in, they will see your Codebase when they visit the Docuemntation or Playtest pages on this site.',
            {
                type: 'actions',
                actions: [
                    { label: 'Open playtest engine', page: 'playtest engine', sendId: '' },
                ]
            }
        ]
    },
    {
        title: 'publishing',
        blocks: [
            'When you create a new Codebase, it will default to Draft status (the status of your Codebase appears in the top-right of the Documentation screen). When you believe your Codebase is ready to market to other users on this site, click the "publish" button.',
            'After that, your Codebase will advance to "Under Review" status.',
            {
                type: 'callout',
                tone: 'step',
                label: 'under review',
                text: 'While your Codebase is in this status, the "publish" button will be disabled while Malware administrators review your Codebase for approval.'
            },
            'After admins have reviewed (typically 7-9 days), your Codebase will be moved into one of two statuses:',
            {
                type: 'callout',
                tone: 'step',
                label: 'rework required',
                text: 'Admins have determined that your Codebase is not yet ready to publish. If your Codebase is placed into this status, they will also provide a link to "review notes" that will provide additional recommendations on how to better prepare the Codebase for publication. The "publish" button will be reenabled so that you can resubmit your Codebase for review after completing any necessary modifications.',
            },
            {
                type: 'callout',
                tone: 'step',
                label: 'published',
                text: 'If your Codebase is approved for publication, it will be made available in the Shop section of this site, and you can begin earning commissions when it is purchased (see below). The Codebase will be frozen and the "edit" option will be permanently disabled.'
            }
        ]
    },
    {
        title: 'earning_commissions',
        blocks: [
            'Once your Codebase is published, you are eligible to earn commissions when visitors to this site purchase your Codebase. At this time, our commission schedule is simple: you will earn $2 for each copy of your Codebase that is sold.',
            'In order to earn commissions on your Codebase, you must accept the Malware Product Commission agreement. No commissions are paid until this agreement is signed, so we recommend signing it before publishing any Codebases.',
            {
                type: 'callout',
                tone: 'warning',
                label: 'accepting_terms',
                text: 'You can access the Malware Product Commission agreement in your user profile. Type "profile" and click the "commissions agreement" button to review and sign the agreement.'
            },
            'You can view sales statistics for any Codebases you design, along with a ledger of commissions earned and paid, by typing "commissions" in the command prompt or by clicking the "commissions" button in your user profile.',
            {
                type: 'actions',
                actions: [
                    { label: 'commissions', page: 'profile', sendId: 'commissions' },
                ]
            }
        ]
    },
    {
        title: 'balancing_codebase_power',
        blocks: [
            'Severely overpowered or underpowered Codebases are unlikely to be approved for publication. While the power of a particular Codebase is not easily quantified and requires some level of subjective assessment, we recommend employing the following principles:',
            {
                type: 'list',
                items: [
                    'Consider adding play conditions to expecially powerful cards. For example, the card may only be played later in the game when certain milestones have been met (e.g. occamsRazor() in Sherlock Protocol). Or perhaps there is some negative effect or trade-off when playing the card (e.g. pokeAzathoth in Miskatonic College of CS).',
                    'Prevent loops. For example, do not design a listener that activates when y decreases if you also have a function that decreases y when your program runs.',
                    'We love clever mechanics. However, try not to combine too many mechanics in a single Codebase. Developers may find interdependencies confusing, and can sometimes result in cards that are interesting in theory but difficult to play in practice.',
                    'Playtest your Codebase against a single virus. As a general of rule of thumb, if you can defeat the virus about 55-70% of the time, it is probably an apporpriately powered Codebase.',
                    'Avoid cards that have no real net effect on gameplay. For example, a card that just allows you to draw another card is effectively a throwaway card (it simple replaces itself).'
                ]
            }
        ]
    },
    {
        title: 'additional_design_guidance',
        blocks: [
            'Below are a few additional tips for designing and publishing Codebases.',
            {
                type: 'list',
                items: [
                    'We love pixel art, but don\'t strictly require it. However, your card art should reflect the specific theme of your Codebase as well as the broader theme of Malware (i.e. this game is about cybersecurity, coding, etc.).',
                    'This should go without saying, but we will not publish any racist, sexist, or explicit content.',
                    'We also can\'t publish any copyrighted material. Sorry - no Bladerunner or Pokemon-themed Codebases! Make sure your content is original or in the public domain.',
                    'Remember that your Codebase will be played alongside other Codebases. So before you submit it for publication, be sure ot playtest it alongside other, established Codebases against multiple viruses.',
                    'Do not submit more than one Codebase for publication at the same time. Our capacity for reviewing Codebases is limited.'
                ]
            }
        ]
    },
];

export function DevGuide(props) {
    return (
        <ReadmePage
            fileName="README.devguide.md"
            title="Malware Developer's Guide"
            subtitle="Developing your own Codebase on Malware is easy. With approval, you can even list your Codebase on our online marketplace and earn commissions when other developers buy it. This guide covers everything you need to know about developing your own Codebases."
            version="0.1.0"
            status="draft"
            sections={RULE_SECTIONS}
            changePage={props.changePage}
        />
    );
}
